// Modules
import { produce } from 'immer'

// Types
import {
  CREATE_TRANSACTION_LOADING,
  CREATE_TRANSACTION_RESET_FORM,
  GET_ASSERT_LIST,
  SET_ASSERT_LIST,
  SET_ASSERT_LIST_LOADING,
  SET_SHOW_MOBILE_CREATE_TRANSACTION_MODAL,
  SET_SHOW_MOBILE_TRADE_BLOCK_MODAL,
  SET_SHOW_MOBILE_POSITION_MODAL,
} from 'store/actions/TransactionCreation/types'

const initialState = {
  assertList: null,
  assertListLoading: true,
  transactionCreationLoading: false,
  transactionCreationResetFormAction: null,
  isMobileCreateTransactionModalOpen: false,
  isMobileMarketWatchModalOpen: false,
  isOrderBottomBarModalOpen: false,
}

const transactionCreationReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ASSERT_LIST:
      return produce(state, (draft) => {
        draft.assertList = action.payload
      })

    case GET_ASSERT_LIST:
      return produce(state, (draft) => {
        draft.assertListLoading = true
      })

    case SET_ASSERT_LIST_LOADING:
      return produce(state, (draft) => {
        draft.assertListLoading = action.payload
      })

    case CREATE_TRANSACTION_LOADING:
      return produce(state, (draft) => {
        draft.transactionCreationLoading = action.payload
      })

    case CREATE_TRANSACTION_RESET_FORM:
      return produce(state, (draft) => {
        draft.transactionCreationResetFormAction = action.payload
      })

    case SET_SHOW_MOBILE_CREATE_TRANSACTION_MODAL:
      return produce(state, (draft) => {
        draft.isMobileCreateTransactionModalOpen = action.payload
      })

    case SET_SHOW_MOBILE_TRADE_BLOCK_MODAL:
      return produce(state, (draft) => {
        draft.isMobileMarketWatchModalOpen = action.payload
      })

    case SET_SHOW_MOBILE_POSITION_MODAL:
      return produce(state, (draft) => {
        draft.isOrderBottomBarModalOpen = action.payload
      })

    default:
      return state
  }
}

export default transactionCreationReducer
